module.exports = __webpack_public_path__ + "img/acqua-palace_toboggan-foam.51f8d155.jpeg";